import { ReactComponent as WatchLaterFill } from 'assets/icons/icon-watch-later-fill.svg';

export default WatchLaterFill;
